/**
 * WARNING: This file is auto-generated. Please do not modify it.
 *
 * If you need to make changes, please see the README.md file in the root of this repository.
 */

import { AxiosRequestConfig, AxiosResponse } from 'axios';

import { Controller } from '../Controller';

import {
  GetV2TeamsUrlSimulationsPrototypeAccessByTeamIdAndPrototypeIdParams,
  PutV2TeamsUrlSimulationsPrototypeAccessByTeamIdAndPrototypeIdParams,
  GetV2TeamsUrlSimulationsByTeamIdParams,
  PostV2TeamsUrlSimulationsByTeamIdParams,
  PostV2TeamsUrlSimulationsCancelByTeamIdAndSimulationIdParams,
  PostV2TeamsUrlSimulationsPrototypeMoveByTeamIdAndPrototypeIdParams,
  PostV2TeamsUrlSimulationsExtendedByTeamIdParams,
  PostV2TeamsUrlSimulationsExtendedCancelByTeamIdAndReviewIdParams,
  GetV2TeamsUrlSimulationsByTeamIdAndSimulationIdParams,
  GetV2TeamsUrlSimulationsStepsByTeamIdAndSimulationIdParams,
  GetV2TeamsUrlSimulationsPrototypesByTeamIdParams,
  GetV2TeamsUrlSimulationsPrototypeByTeamIdAndPrototypeIdParams,
  DeleteV2TeamsUrlSimulationsPrototypeByTeamIdAndPrototypeIdParams,
  GetV2TeamsUrlSimulationsExtendedByTeamIdAndReviewIdParams,
  GetV2TeamsUrlSimulationsExtendedPrototypeByTeamIdAndPrototypeIdParams,
  PostV2TeamsUrlSimulationsExtendedByTeamIdQuery,
  GetV2TeamsUrlSimulationsPrototypesByTeamIdQuery,
  PutV2TeamsUrlSimulationsPrototypeAccessByTeamIdAndPrototypeIdBody,
  PostV2TeamsUrlSimulationsByTeamIdBody,
  PostV2TeamsUrlSimulationsPrototypeMoveByTeamIdAndPrototypeIdBody,
  PostV2TeamsUrlSimulationsExtendedByTeamIdBody,
  GetV2TeamsUrlSimulationsPrototypeAccessByTeamIdAndPrototypeIdResponse,
  PutV2TeamsUrlSimulationsPrototypeAccessByTeamIdAndPrototypeIdResponse,
  GetV2TeamsUrlSimulationsByTeamIdResponse,
  PostV2TeamsUrlSimulationsByTeamIdResponse,
  PostV2TeamsUrlSimulationsCancelByTeamIdAndSimulationIdResponse,
  PostV2TeamsUrlSimulationsPrototypeMoveByTeamIdAndPrototypeIdResponse,
  PostV2TeamsUrlSimulationsExtendedByTeamIdResponse,
  PostV2TeamsUrlSimulationsExtendedCancelByTeamIdAndReviewIdResponse,
  GetV2TeamsUrlSimulationsByTeamIdAndSimulationIdResponse,
  GetV2TeamsUrlSimulationsStepsByTeamIdAndSimulationIdResponse,
  GetV2TeamsUrlSimulationsPrototypesByTeamIdResponse,
  GetV2TeamsUrlSimulationsPrototypeByTeamIdAndPrototypeIdResponse,
  GetV2TeamsUrlSimulationsExtendedByTeamIdAndReviewIdResponse,
  GetV2TeamsUrlSimulationsExtendedPrototypeByTeamIdAndPrototypeIdResponse,
} from '../types';

export class URLSimulations extends Controller {
  async getV2TeamsUrlSimulationsPrototypeAccessByTeamIdAndPrototypeId<
    T extends GetV2TeamsUrlSimulationsPrototypeAccessByTeamIdAndPrototypeIdResponse,
    D,
    C
  >(
    {
      teamId,
      prototypeId,
    }: GetV2TeamsUrlSimulationsPrototypeAccessByTeamIdAndPrototypeIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/teams/${teamId}/url-simulations/prototype/${prototypeId}/access`,
      axiosConfig
    );
  }

  async putV2TeamsUrlSimulationsPrototypeAccessByTeamIdAndPrototypeId<
    T extends PutV2TeamsUrlSimulationsPrototypeAccessByTeamIdAndPrototypeIdResponse,
    D,
    C extends PutV2TeamsUrlSimulationsPrototypeAccessByTeamIdAndPrototypeIdBody
  >(
    body: C,
    {
      teamId,
      prototypeId,
    }: PutV2TeamsUrlSimulationsPrototypeAccessByTeamIdAndPrototypeIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.put<T, AxiosResponse<T, D>, C>(
      `/v2/teams/${teamId}/url-simulations/prototype/${prototypeId}/access`,
      body,
      axiosConfig
    );
  }

  async getV2TeamsUrlSimulationsByTeamId<
    T extends GetV2TeamsUrlSimulationsByTeamIdResponse,
    D,
    C
  >(
    { teamId }: GetV2TeamsUrlSimulationsByTeamIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/teams/${teamId}/url-simulations`,
      axiosConfig
    );
  }

  async postV2TeamsUrlSimulationsByTeamId<
    T extends PostV2TeamsUrlSimulationsByTeamIdResponse,
    D,
    C extends PostV2TeamsUrlSimulationsByTeamIdBody
  >(
    body: C,
    { teamId }: PostV2TeamsUrlSimulationsByTeamIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      `/v2/teams/${teamId}/url-simulations`,
      body,
      axiosConfig
    );
  }

  async postV2TeamsUrlSimulationsCancelByTeamIdAndSimulationId<
    T extends PostV2TeamsUrlSimulationsCancelByTeamIdAndSimulationIdResponse,
    D,
    C extends null
  >(
    body: C,
    {
      teamId,
      simulationId,
    }: PostV2TeamsUrlSimulationsCancelByTeamIdAndSimulationIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      `/v2/teams/${teamId}/url-simulations/${simulationId}/cancel`,
      body,
      axiosConfig
    );
  }

  async postV2TeamsUrlSimulationsPrototypeMoveByTeamIdAndPrototypeId<
    T extends PostV2TeamsUrlSimulationsPrototypeMoveByTeamIdAndPrototypeIdResponse,
    D,
    C extends PostV2TeamsUrlSimulationsPrototypeMoveByTeamIdAndPrototypeIdBody
  >(
    body: C,
    {
      teamId,
      prototypeId,
    }: PostV2TeamsUrlSimulationsPrototypeMoveByTeamIdAndPrototypeIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      `/v2/teams/${teamId}/url-simulations/prototype/${prototypeId}/move`,
      body,
      axiosConfig
    );
  }

  async postV2TeamsUrlSimulationsExtendedByTeamId<
    T extends PostV2TeamsUrlSimulationsExtendedByTeamIdResponse,
    D,
    C extends PostV2TeamsUrlSimulationsExtendedByTeamIdBody
  >(
    body: C,
    { teamId }: PostV2TeamsUrlSimulationsExtendedByTeamIdParams,
    query: PostV2TeamsUrlSimulationsExtendedByTeamIdQuery,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      this.composeUrl(`/v2/teams/${teamId}/url-simulations/extended`, query),
      body,
      axiosConfig
    );
  }

  async postV2TeamsUrlSimulationsExtendedCancelByTeamIdAndReviewId<
    T extends PostV2TeamsUrlSimulationsExtendedCancelByTeamIdAndReviewIdResponse,
    D,
    C extends null
  >(
    body: C,
    {
      teamId,
      reviewId,
    }: PostV2TeamsUrlSimulationsExtendedCancelByTeamIdAndReviewIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      `/v2/teams/${teamId}/url-simulations/extended/${reviewId}/cancel`,
      body,
      axiosConfig
    );
  }

  async getV2TeamsUrlSimulationsByTeamIdAndSimulationId<
    T extends GetV2TeamsUrlSimulationsByTeamIdAndSimulationIdResponse,
    D,
    C
  >(
    {
      teamId,
      simulationId,
    }: GetV2TeamsUrlSimulationsByTeamIdAndSimulationIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/teams/${teamId}/url-simulations/${simulationId}`,
      axiosConfig
    );
  }

  async getV2TeamsUrlSimulationsStepsByTeamIdAndSimulationId<
    T extends GetV2TeamsUrlSimulationsStepsByTeamIdAndSimulationIdResponse,
    D,
    C
  >(
    {
      teamId,
      simulationId,
    }: GetV2TeamsUrlSimulationsStepsByTeamIdAndSimulationIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/teams/${teamId}/url-simulations/${simulationId}/steps`,
      axiosConfig
    );
  }

  async getV2TeamsUrlSimulationsPrototypesByTeamId<
    T extends GetV2TeamsUrlSimulationsPrototypesByTeamIdResponse,
    D,
    C
  >(
    { teamId }: GetV2TeamsUrlSimulationsPrototypesByTeamIdParams,
    query: GetV2TeamsUrlSimulationsPrototypesByTeamIdQuery,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      this.composeUrl(`/v2/teams/${teamId}/url-simulations/prototypes`, query),
      axiosConfig
    );
  }

  async getV2TeamsUrlSimulationsPrototypeByTeamIdAndPrototypeId<
    T extends GetV2TeamsUrlSimulationsPrototypeByTeamIdAndPrototypeIdResponse,
    D,
    C
  >(
    {
      teamId,
      prototypeId,
    }: GetV2TeamsUrlSimulationsPrototypeByTeamIdAndPrototypeIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/teams/${teamId}/url-simulations/prototype/${prototypeId}`,
      axiosConfig
    );
  }

  async deleteV2TeamsUrlSimulationsPrototypeByTeamIdAndPrototypeId<
    T,
    D,
    C extends null
  >(
    {
      teamId,
      prototypeId,
    }: DeleteV2TeamsUrlSimulationsPrototypeByTeamIdAndPrototypeIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined,
    body?: C
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.delete<T, AxiosResponse<T, D>, C>(
      `/v2/teams/${teamId}/url-simulations/prototype/${prototypeId}`,
      { ...axiosConfig, data: body }
    );
  }

  async getV2TeamsUrlSimulationsExtendedByTeamIdAndReviewId<
    T extends GetV2TeamsUrlSimulationsExtendedByTeamIdAndReviewIdResponse,
    D,
    C
  >(
    {
      teamId,
      reviewId,
    }: GetV2TeamsUrlSimulationsExtendedByTeamIdAndReviewIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/teams/${teamId}/url-simulations/extended/${reviewId}`,
      axiosConfig
    );
  }

  async getV2TeamsUrlSimulationsExtendedPrototypeByTeamIdAndPrototypeId<
    T extends GetV2TeamsUrlSimulationsExtendedPrototypeByTeamIdAndPrototypeIdResponse,
    D,
    C
  >(
    {
      teamId,
      prototypeId,
    }: GetV2TeamsUrlSimulationsExtendedPrototypeByTeamIdAndPrototypeIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/teams/${teamId}/url-simulations/extended/prototype/${prototypeId}`,
      axiosConfig
    );
  }
}
